import { Modal, Box, Button } from '@mui/material';
import { modalStyle } from './modalStyle';

interface ConfirmModalProps {
  isOpen: boolean;
  heading: string;
  message: string;
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmModal({ isOpen, heading, message, confirmLabel, onCancel, onConfirm }: ConfirmModalProps) {
  return (
    <Modal open={isOpen} onClose={onCancel}>
      <Box sx={{ ...modalStyle }}>
        <h3>{heading}</h3>
        <p>{message}</p>
        <div style={{ textAlign: 'right' }}>
          <Button style={{ marginRight: '5px' }} onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onConfirm}>{confirmLabel}</Button>
        </div>
      </Box>
    </Modal>
  );
}
